<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center text-h6 text-md-h5 text-lg-h4">
        Suite23 - {{ $t("titolo") }}
      </div>

      <v-spacer></v-spacer>

      <v-btn @click="setLocale('en')">ENG</v-btn>
      <v-btn @click="setLocale('es')">ESP</v-btn>
      <v-btn @click="setLocale('fr')">FRA</v-btn>
      <v-btn @click="setLocale('it')">ITA</v-btn>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
    },
  },
};
</script>
